import Marquee from "react-fast-marquee";

const WORDS = ["DISCIPLINE", "SAFETY", "PRECISION", "MIDWEST MADE", "ACCOUNTABILITY", "REPETITION"];

export default function BrandMarquee() {
  return (
    <div className="border-y border-white/10 bg-brand-surface/40 py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-black uppercase text-2xl md:text-4xl tracking-tight text-brand-ink/70 px-8">
              {w}
            </span>
            <span className="h-2 w-2 bg-brand-orange rotate-45" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
